import {
  AttributeConfigurationDc,
  AttributeSelectorType,
  AttributeType,
  LayerReferenceConfigurationDc,
} from "@evergis/api";
import { Dropdown, IOption } from "@evergis/ui";
import { isEmpty } from "lodash";
import React, { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAttributeSelectorOptions } from "../hooks/useAttributeSelectorOptions";
import { AttributeSelectorContainer } from "./styled";

export interface AttributeSelectorProps {
  attributeType?: AttributeType;
  layerReferences?: LayerReferenceConfigurationDc[];
  attributeConfiguration?: AttributeConfigurationDc;
  onChangeSelectorType?: (value: AttributeSelectorType) => void;
  onChangeReference?: (value: string[]) => void;
}

const DICTIONARY_TYPES = [AttributeSelectorType.SelectFromHandBook, AttributeSelectorType.ViewHandBook];

export const AttributeSelectorTypeForm: FC<AttributeSelectorProps> = ({
  attributeType,
  layerReferences,
  attributeConfiguration,
  onChangeSelectorType,
  onChangeReference,
}) => {
  const { t } = useTranslation("common");
  const { attributeSelectorType, layerReferenceId, attributeName } = attributeConfiguration || {};
  const { referenceLayersLoading, selectorTypesOptions, dictionariesOptions } = useAttributeSelectorOptions(
    layerReferences,
    attributeType,
    attributeName,
  );

  useEffect(() => {
    if (DICTIONARY_TYPES.includes(attributeSelectorType) && isEmpty(layerReferenceId)) {
      const firstAttribute = dictionariesOptions[0];

      onChangeReference([firstAttribute?.value]);
    } else if (!DICTIONARY_TYPES.includes(attributeSelectorType)) {
      onChangeReference(null);
    }
  }, [attributeSelectorType]);

  return (
    <AttributeSelectorContainer>
      <Dropdown
        label={t("inputType")}
        options={selectorTypesOptions}
        value={attributeSelectorType}
        width={"18.5rem"}
        zIndex={99999}
        loading={referenceLayersLoading}
        onChange={([option]: IOption[]) => onChangeSelectorType(option.value as AttributeSelectorType)}
      />
      {DICTIONARY_TYPES.includes(attributeSelectorType) && (
        <Dropdown
          label={attributeSelectorType === AttributeSelectorType.SelectFromHandBook ? t("dictionary") : t("layer")}
          options={dictionariesOptions}
          value={
            attributeSelectorType === AttributeSelectorType.ViewHandBook
              ? layerReferenceId
              : layerReferenceId && layerReferenceId[0]
          }
          width={"18.5rem"}
          loading={referenceLayersLoading}
          zIndex={99999}
          multiple={attributeSelectorType === AttributeSelectorType.ViewHandBook}
          onChange={(options: IOption[]) => onChangeReference(options.map(({ value }) => value))}
        />
      )}
    </AttributeSelectorContainer>
  );
};
